import { styled, ToggleButtonGroup, Typography } from '@mui/material';
import { IconButton } from '@sdb/planning-ui';

import { protocolIconSize } from '../../Protocols.styles';

/** The phases of a rule, closer together than the form's sections */
export const PhaseList = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2)
}));

/** One phase, without a box of its own: consecutive phases are separated by a thin line */
export const PhaseBox = styled('fieldset')(({ theme }) => ({
  border: 'none',
  padding: 0,
  margin: 0,
  minWidth: 0,
  '& + &': {
    borderTop: `1px solid ${theme.palette.divider}`,
    paddingTop: theme.spacing(2)
  },
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2.5)
}));

/** Name, type and trash can on one line, so the type needs no row of its own */
export const PhaseHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2)
}));

/** Periodiek / Totaal as a toggle, next to the phase's name */
export const PhaseType = styled(ToggleButtonGroup)(({ theme }) => ({
  '& .MuiToggleButton-root': {
    padding: theme.spacing(0.25, 1.5),
    textTransform: 'none'
  }
}));

/** "Fase 1", "Fase 2": the phase's name, bold above its fields */
export const PhaseName = styled(Typography)(({ theme }) => ({
  fontWeight: theme.typography.fontWeightBold
}));

/** A phase's buttons, at the right end of its line */
export const PhaseActions = styled('span')(({ theme }) => ({
  display: 'flex',
  marginLeft: 'auto',
  gap: theme.spacing(0.5)
}));

/**
 * The pencil, check and trash can of a phase and the plus next to Verloop: the same size as the
 * pencil and trash can on the protocol's detail
 */
export const PhaseIconButton = styled(IconButton)(({ theme }) => ({
  '& svg': protocolIconSize(theme)
}));

/** Van week, T/m week, Aantal and Per wk side by side; a total phase leaves the last cell empty */
export const FieldRow = styled('div')(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
  gap: theme.spacing(1)
}));

/**
 * The live summary at the top of the form, right under the drawer title: dashed while a phase is
 * still incomplete, solid once it reads as a whole.
 */
export const Summary = styled('div', {
  shouldForwardProp: (prop) => prop !== 'complete'
})<{ complete: boolean }>(({ theme, complete }) => ({
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(1, 1.5),
  marginTop: theme.spacing(4),
  border: `1px ${complete ? 'solid' : 'dashed'} ${
    complete ? theme.palette.primary.light : theme.palette.divider
  }`,
  color: complete ? theme.palette.text.primary : theme.palette.text.secondary
}));

/** The end of the summary: the sessions over the whole rule */
export const SummaryTotal = styled('span')(({ theme }) => ({
  fontWeight: theme.typography.fontWeightBold
}));
